export default __webpack_public_path__ + "static/media/solution.471b5772.svg";